import { applicantPropertyCpfUsage } from "./propertyLoanOwnership";

export const HALF_CAVEAT_LTV = 0.85;
export const HALF_CAVEAT_TERMS = [3, 6, 9, 12];
export const FIRST_CHARGE_TERMS = Array.from(
  { length: 25 },
  (_, index) => (index + 1) * 12,
);
export const propertyLoanTenureOptions = (type, form = {}) =>
  Number(type) === 0 && form.loanPaymentType !== "interest"
    ? FIRST_CHARGE_TERMS
    : HALF_CAVEAT_TERMS;
export const propertyLoanLtvLimit = (propertyType) =>
  propertyType === "land" ? 0.85 : 0.8;

export const halfCaveatLimit = (form, propertyValue) => {
  if (form.propertyOwnership !== "TenancyInCommon") return 0;
  const share = Number(form.propertyShare) / 100;
  if (!Number.isFinite(share) || share <= 0 || share > 1) return 0;
  const limit =
    (Number(propertyValue) * HALF_CAVEAT_LTV -
      Number(form.oustandingLoan || 0)) *
      share -
    applicantPropertyCpfUsage(form);
  return Number.isFinite(limit)
    ? Math.max(0, Math.floor((limit + 1e-8) * 100) / 100)
    : 0;
};

export const halfCaveatLtv = (form) => {
  const share = Number(form.propertyShare) / 100;
  const shareValue = Number(form.estimatedPropertyValue) * share;
  if (!Number.isFinite(shareValue) || shareValue <= 0) return null;
  return (
    ((Number(form.loanAmount || 0) +
      applicantPropertyCpfUsage(form) +
      Number(form.oustandingLoan || 0) * share) /
      shareValue) *
    100
  );
};

export const propertyLoanMonths = (type, form = {}) => {
  // Keep saved year-based terms readable for applications made before the
  // interest-only restriction, while also accepting the new short terms.
  const terms = Number(type) === 0
    ? [...FIRST_CHARGE_TERMS, ...(form.loanPaymentType === "interest" ? HALF_CAVEAT_TERMS : [])]
    : HALF_CAVEAT_TERMS;
  const months = Number(form.loanTenureMonths);
  if (terms.includes(months)) return months;
  // Old records did not save tenure explicitly. Retain their existing schedule.
  if (form.loanTenureMonths == null && form.loanRepaymentSchedule?.length > 0)
    return form.loanRepaymentSchedule.length;
  const options = propertyLoanTenureOptions(type, form);
  return options[options.length - 1];
};

export const propertyLoanMonthlyRate = (type) =>
  Number(type) === 2 ? 0.02 : Number(type) === 0 ? 0.0083 : 0.025;

export const propertyLoanName = (type) =>
  ["Equity Term Loan", "Bridging Loan", "Half Caveat Loan"][Number(type)] ||
  "Property Loan";

export const propertyLoanTenureLabel = (type, form = {}) => {
  const months = propertyLoanMonths(type, form);
  if (Number(type) === 2) return `${months} months · renewable`;
  if (Number(type) === 0 && !(form.loanPaymentType === "interest" && months <= 12)) {
    return `${months / 12} ${months === 12 ? "Year" : "Years"}`;
  }
  return `${months} months`;
};

export const propertyLoanRateLabel = (type) =>
  Number(type) === 2
    ? "1.5–2.5% per month"
    : Number(type) === 0
      ? "10% p.a"
      : "2.5% per month";
